module.exports = __webpack_public_path__ + "assets/images/ae79c4fa3f9ffc8199a38b1cda20feff.png";